import styled from 'react-emotion/macro';
import { DatePicker, Button } from 'antd';
import {
  width, space,
} from 'styled-system';

// The goal is to hide the default AntD input box that shows merely week numbers.
// "display: none" cannot be use in this context because the position of the inputbox
// determines the popup location. Have to hide it via changing the opacity.
export const WeekWrapper = styled(DatePicker.WeekPicker)` &&& {
  position: absolute;
  left: 0;
  opacity: 0;
  z-index: -1;
}`;

export const ButtonGroup = styled(Button.Group)` &&& {
  ${space}

  button:nth-child(2) {
    ${width}
  }
}`;

export const Divide = styled.span`
  &::before {
    content: ' - ';
    ${space};
  }
`;
